/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fQPf2UiMEMhB52C8QQXwWe

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariants_0TMeaYfWn538 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: 0tMEAYfWN538/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariants_0TMeaYfWn538,
});
